// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-PromptBackgroundContainer_cls1__irNDf","cls2":"StyledComponents-PromptBackgroundContainer_cls2__IoC8V StyledComponents-PromptBackgroundContainer_cls1__irNDf"};